import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/grid";

import { useEffect, useState } from "react";
import axios from "axios";
import Banners from "./Banners";
import Categories from "./Categories";
import Trending from "./Trending";
import BestSellers from "./BestSellers";
import { BASE_URL } from "../../config";
import { Loading } from "../Common/Loading";

const Home = () => {
  const [data, setData] = useState({
    banners: "",
    categories: "",
    trending: "",
    sellers: "",
  });
  const { banners, categories, trending, sellers } = data;

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await axios
      .get(`${BASE_URL}`)
      .then((response) => {
        setData({
          ...data,
          banners: response.data.banners,
          categories: response.data.categories,
          trending: response.data.new,
          sellers: response.data.recommend,
        });
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (trending.length === 0) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <Banners data={banners} />
      <Categories data={categories} />
      <Trending data={trending} />
      {sellers.length > 0 ? <BestSellers data={sellers} /> : ""}
    </>
  );
};

export default Home;
